// extracted by mini-css-extract-plugin
module.exports = {"el":"BtnScroll_el__3bBpY"};